
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_8126_1148)","stroke":"#fff","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M15.714 7.857H4.286c-.79 0-1.429.64-1.429 1.429v8.571c0 .79.64 1.429 1.429 1.429h11.428c.79 0 1.429-.64 1.429-1.429V9.286c0-.79-.64-1.429-1.429-1.429z"}}),_c('path',{attrs:{"d":"M15 7.857V5.714a5 5 0 00-10 0v2.143M10 14.286a.714.714 0 100-1.429.714.714 0 000 1.429z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_8126_1148"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h20v20H0z"}})])])])
          )
        }
      }
    